import { ApolloLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from 'apollo-upload-client';

const cache = new InMemoryCache();

const authLink2 = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('token');
  const initialToken = localStorage.getItem('initialToken');
  let imp = {};
  if (initialToken) {
    imp = {
      imp: initialToken,
    };
  }

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      ...imp
    }
  });

  // Call the next link in the middleware chain.
  return forward(operation);
});

const link = ApolloLink.from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        if (message === 'Not Authorised!') {
          localStorage.removeItem('token');
          window.location.replace('/logout');
        }
        try {
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
          );
        } catch (error) {
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          );
        }
      });
    }

    if (networkError) console.log(`[Network error]: ${networkError}`);
  }),
  authLink,
  createUploadLink({uri:(window as any)._env_.REACT_APP_GRAPHQL_URL})
]);

const client = new ApolloClient({
  link,
  cache,
});

export default client;